var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.667 423.721H8.828A8.829 8.829 0 0 1 0 414.893V97.101a8.829 8.829 0 0 1 8.828-8.828h161.839v335.448z",
    fill: "#41479b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M170.67 88.277h170.67v335.45H170.67z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.721H341.333V88.273h161.839A8.829 8.829 0 0 1 512 97.101v317.792a8.828 8.828 0 0 1-8.828 8.828z",
    fill: "#ff4b55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTd);
export default __webpack_public_path__ + "static/media/td.c0931da9da294d61e4a0f3882dc3e202.svg";
export { ForwardRef as ReactComponent };